'use strict';

var sharedState = require('./sharedState');
const $cache = sharedState.$cache;

var commonFeatures = require('./commonFeatures');

const init = () => {
    // Handle Passengers
    $cache.tripPassengers.closest('.form-group').on('click', (e) => {
        e.preventDefault();

        $cache.popupPassengers.addClass('visible');
    });

    // Close Passengers popup
    $cache.body.on('click', (e) => {
        // Popup is not visible, OR clicked element is detached
        if ($('.popup-travel-passengers.visible').length === 0 || !$.contains(document, e.target)) {
            return;
        }

        if ($(e.target).closest('.popup-travel-passengers, .award-search__trip-passengers').length === 0) {
            $('.popup-travel-passengers').removeClass('visible');
        }
    });

    // Handle inner popup features
    handlePassengersPopupBehavior();

    // Update passengers input on init
    updatePassengersData();
    updatePassengersInput();
};

const updatePassengersButtons = () => {
    const formSettings = $cache.mainWrapper.data('settings');
    const maxPassengers = formSettings.maxPassengers;
    sharedState.debug('updatePassengersButtons', 'maxPassengers', maxPassengers);

    let adultCount = parseInt($cache.adultPassengers.val());
    let childCount = parseInt($cache.childPassengers.val());
    let babyCount = parseInt($cache.babyPassengers.val());

    let currentPassengersCount = adultCount + childCount;

    let minAdultCount = 1;
    let minChildCount = 0;
    let minBabyCount = 0;

    $cache.adultPassengers.parent().find('.minus-btn').prop('disabled', adultCount <= Math.max(minAdultCount, babyCount));
    $cache.adultPassengers.parent().find('.plus-btn').prop('disabled', currentPassengersCount >= maxPassengers);

    $cache.childPassengers.parent().find('.minus-btn').prop('disabled', childCount <= minChildCount);
    $cache.childPassengers.parent().find('.plus-btn').prop('disabled', currentPassengersCount >= maxPassengers);

    $cache.babyPassengers.parent().find('.minus-btn').prop('disabled', babyCount <= minBabyCount);
    $cache.babyPassengers.parent().find('.plus-btn').prop('disabled', babyCount >= adultCount);
};

const handlePassengersPopupBehavior = () => {
    // Handle click on dropout
    $cache.popupPassengers.on('click', (e) => {
        if ($(e.target).hasClass('ita-popup')) {
            $cache.popupPassengers.removeClass('visible');
        }
    });

    // Handle click on close button
    $cache.popupPassengers.on('click', '.popup-travel-passengers__close', (e) => {
        $cache.popupPassengers.removeClass('visible');
    });

    // Init input buttons
    updatePassengersButtons();

    // Handle +/- buttons
    $cache.popupPassengers.on('click', '.popup-travel-passengers-item button', (e) => {
        let $target = $(e.currentTarget);
        let $input = $target.parent().find('input');
        let currentValue = parseInt($input.val());
        let newValue = $target.hasClass('minus-btn') ? currentValue - 1 : currentValue + 1;
        $input.val(newValue);
        updatePassengersButtons();

        // Update passengers input
        updatePassengersData();
        updatePassengersInput();

        // Check form validity
        $cache.mainWrapper.trigger('form:validityCheck');
    });

    // Handle apply button
    $cache.passengersApplyButton.on('click', (e) => {
        e.preventDefault();

        // Close popup
        $cache.popupPassengers.removeClass('visible');
    })
};

const updatePassengersData = () => {
    let data = {}

    // Prepare data and tokens
    $cache.adultPassengers.add($cache.childPassengers).add($cache.babyPassengers).each(function () {
        let $item = $(this);

        let type = $item.attr('name').split('-')[1];
        let count = parseInt($item.val());
        data[type] = count;
    });

    // Update data attribute and value
    $cache.tripPassengers.attr('data-passengers', JSON.stringify(data));
};

const updatePassengersInput = () => {
    let passengersData = null;

    try {
        passengersData = JSON.parse($cache.tripPassengers.attr('data-passengers'));
    } catch (error) {
        sharedState.debug('updatePassengersInput', 'error', error);
        return;
    }

    let tokens = [];

    // Prepare data and tokens
    $cache.adultPassengers.add($cache.childPassengers).add($cache.babyPassengers).each(function () {
        let $item = $(this);
        let type = $item.attr('name').split('-')[1];
        let count = passengersData[type];

        $item.val(count)
        let $titleWrapper = $item.closest('.popup-travel-passengers-item').find('.popup-travel-passengers-item__title-wrapper');
        let title = $titleWrapper.find('.popup-travel-passengers-item__title').text();
        let subtitle = $titleWrapper.find('.popup-travel-passengers-item__subtitle').text();
        if (count > 0) {
            tokens.push(subtitle ? `${count} ${title} (${subtitle})` : `${count} ${title}`);
        }
    });

    // Update value
    $cache.tripPassengers.val(tokens.join(', '));
};

module.exports = {
    init: init,
    updatePassengersInput: updatePassengersInput,
};
